import React from 'react';

const User_header = ({name, country, FrogedId}) => {
    return (
        <div>
               {/* --- INFORMACIÓN GENERAL --- */}
     
        </div>
    );
};

export default User_header;